module.exports = __webpack_public_path__ + "img/404.3098ef3e.png";